import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import VueRouter from 'vue-router';
import Print from 'vue-print-nb';
import dayjs from "dayjs";
import * as echarts from 'echarts'
import Base64 from "./components/base64/index"
import JsonExcel from "vue-json-excel";
import store from "./store"; // 引入 store 文件

Vue.prototype.$echarts = echarts

Vue.prototype.$Base64 = Base64

Vue.component("downloadExcel",JsonExcel)



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
  
Vue.use(ElementUI)
Vue.use(VueAxios,axios)
Vue.use(Print)  //注册


Vue.config.productionTip = false;

//公共函数
Vue.prototype.setTokens = function (id,token){
  //函数方法
  this.axios
  .get("/api/cgi-bin/token?grant_type=client_credential", {
    params: {
      appid: id,
      secret: token,
    },
  })
  .then(response => {
   return this.ACCESS_TOKEN = response.data.access_token,
   //修改数据库里的token

   this.axios.post("/getUser/SetSecret",{data:{
    id:sessionStorage.getItem("id"),
    token:response.data.access_token,
    time:dayjs().format('YYYY-MM-DD HH:mm:ss')
     }})
  })
 
},



Vue.prototype.getTokens = function(){
          //请求token
            this.axios.post("/getUser/getToken",{data:{
              eid:sessionStorage.getItem("id")
            }}).then(res=>{
              // console.log(res)
              if(res.data.length > 0){
                return this.ACCESS_TOKEN = res.data[0].AccessToken
                // Vue.prototype.$ACCESS_TOKEN = res.data[0].AccessToken
              }
             
            
            })
  
            // 53_LnKoc8AG5H1fVzL_xcTphKsswnLEBV4b0rcSDQ2KXIfGUdxT6nn4BB2sQK_60rZoINVIpBVVJT5Sp2qERJCJShMKJ-t_GhsNB3mq3vnmH4UrhDuf701z0xZ_lREL4shkveuJPhohZdmAboghEHFcAIAQTR
  }

//请求用户token
Vue.prototype.getUserToken = function(){
  //请求用户信息
  this.axios.post("/getUser/Users",{data:{
      Id:sessionStorage.getItem("userId")
  }}).then(res=>{
    // console.log(res)
    if(res.data.length > 0){
      // console.log(res.data)
      this.userData = res.data[0]
      // Vue.prototype.$userData = res.data[0]
    }
    
  })

}



// axios.post("/getUser/getToken",{data:{
//   eid:sessionStorage.getItem("id")
// }}).then(res=>{
//   if(dayjs().diff(dayjs(res.data[0].time),'hour') < 2){
//     //小于2小时token有效
//     Vue.prototype.newToken = res.data[0].AccessToken
//   }else{
//   //大于2小时失效了，重新请求
//   axios.post("/getUser/Users",{data:{
//       Id:sessionStorage.getItem("userId")
//     }}).then(res=>{
//           axios
//           .get("/api/cgi-bin/token?grant_type=client_credential", {
//             params: {
//               appid: res.data[0].appid,
//               secret: res.data[0].secret,
//             },
//           }).then(res=>{
//             Vue.prototype.newToken = res.data.access_token
//           })
//       })
  

//   }

// })

// axios.post("/getUser/Users",{data:{
//   Id:sessionStorage.getItem("userId")
// }}).then(res=>{
// Vue.prototype.newUserData = res.data[0]
// })





new Vue({
  store, // 注册 store
  router,
  render: h => h(App),
}).$mount('#app')
